import { type IntegrationServiceId } from '../../../common/integrations'
import { ROUTER_BASEPATH } from '../../../common/constants'
import { type User } from '../../../models/User'

export const isIntegrationConnected = (currentUser: User, serviceId: IntegrationServiceId) =>
  !!currentUser.integrations?.some((integration) => integration.serviceId === serviceId && (integration.state === 'live' || integration.type === 'oauth2_app'))

export const isIntegrationInvalidated = (currentUser: User, serviceId: IntegrationServiceId) =>
  !!currentUser.integrations?.some((integration) => integration.serviceId === serviceId && integration.state === 'invalid')

export const openIntegrationConnectionSettings = (serviceId: IntegrationServiceId) => {
  window.open(`${ROUTER_BASEPATH}/account/integration-settings/integrations/${serviceId}/settings?connect`, '_blank', 'noopener noreferrer')
}
